import { indexItems } from '@/mocks/homeData';

const colorMap: Record<string, { bg: string; iconBg: string; text: string; border: string }> = {
  accent: { bg: 'hover:bg-accent-50', iconBg: 'bg-accent-100', text: 'text-accent-600', border: 'border-accent-200' },
  primary: { bg: 'hover:bg-primary-50', iconBg: 'bg-primary-100', text: 'text-primary-600', border: 'border-primary-200' },
  secondary: { bg: 'hover:bg-secondary-50', iconBg: 'bg-secondary-100', text: 'text-secondary-600', border: 'border-secondary-200' },
};

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">分类索引</span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">专题合集</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">按题材分类浏览高清电影电视剧，快速找到心仪内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5 max-w-4xl mx-auto">
          {indexItems.map((item, idx) => {
            const c = colorMap[item.color] || colorMap.primary;
            return (
              <div
                key={idx}
                className={`flex flex-col items-center p-5 md:p-6 rounded-xl border ${c.border} bg-background-50 ${c.bg} transition-colors cursor-pointer text-center`}
              >
                <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl ${c.iconBg} flex items-center justify-center mb-3`}>
                  <i className={`${item.icon} ${c.text} text-xl md:text-2xl`}></i>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <span className="text-xs text-foreground-400">{item.count}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}